export const parseJwt = (token) => {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace("-", "+").replace("_", "/");
  return JSON.parse(window.atob(base64));
};


// Safe wrapper to get token from localStorage and parse it
export const getTokenData = () => {
  const token = localStorage.getItem('Token');
  if (!token || token === 'null' || token === 'undefined') return null;
  try {
    return parseJwt(token);
  } catch (error) {
    return null;
  }
};

// Safe wrapper to get specific user data with fallback
export const getUserData = (defaultValue = {}) => {
  const tokenData = getTokenData();
  if (!tokenData || !tokenData.User) return defaultValue;
  return tokenData.User;
};

// Safe wrapper to get SITECODE with fallback
export const getSitecode = (defaultValue = '') => {
  const userData = getUserData();
  return userData.SITECODE || defaultValue;
};
